import { IconButton, Tooltip } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { ExternalLink } from 'components/core/links/external-link'
import { Info } from 'lucide-react'
import { FormattedMessage, useIntl } from 'react-intl'

export const CELTooltip = (): React.ReactElement => {
    const intl = useIntl()
    const sx = { color: 'common.white', '.MuiTypography-root': { textDecoration: 'underline' } }

    return <Tooltip
        slotProps={{ popper: { modifiers: [{ name: 'preventOverflow', options: { padding: 12 } }] } }}
        leaveDelay={200}
        title={
            <FormattedMessage
                defaultMessage="Evaluate a <linkA>CEL expression</linkA>. See the <linkB>ConductorOne CEL documentation</linkB> for help."
                id="cel_expression_rule_condition_tooltip"
                values={{
                    linkA: (chunks) =>
                        <ExternalLink sx={sx} href="https://github.com/google/cel-spec" target="_blank">{chunks}</ExternalLink>,
                    linkB: (chunks) =>
                        <ExternalLink sx={sx} href="https://www.conductorone.com/docs/product/admin/expressions/" target="_blank">{chunks}</ExternalLink>,
                }}
            />
        }
    >
        <IconButton
            size="small"
            sx={{
                color: 'grey.700',
                width: 28,
                height: 28,
                '&:hover': { color: 'grey.900', backgroundColor: 'grey.100' },
            }}
            aria-label={intl.formatMessage({ id: 'editor.celDocumentation', defaultMessage: 'CEL documentation' })}
        >
            <C1Icon icon={Info} sx={{ fontSize: 18 }} />
        </IconButton>
    </Tooltip>
}
